import {Typography} from '@mui/material';

import {DachCountrySelect} from '../../../../../components/DachCountrySelect/DachCountrySelect';
import {DACH_COUNTRY_CODES} from '../../../../../lib/constants';
import {SupportedLanguages} from '../../../../../types/SupportedLanguages';

export const renderCountrySelectField = (formik: any, t: any, lang: SupportedLanguages) => {
  const onCountrySelect = (value?: string) => {
    if (value) {
      formik.setFieldValue('applicantOnboarding.jobSearchPreferences.baseCountry', {
        isoCode: value,
        value: DACH_COUNTRY_CODES.find((entry) => entry.id === value)?.label[lang] || '',
      });
    }
  };

  const onSpecificCountrySelect = (value?: string) => {
    if (value) {
      formik.setFieldValue('applicantOnboarding.jobSearchPreferences.preferredLocations.country', {
        isoCode: value,
        value: DACH_COUNTRY_CODES.find((entry) => entry.id === value)?.label[lang] || '',
      });
    }
  };

  if (formik.values.applicantOnboarding.jobSearchPreferences.locationType === 'anywhere') {
    return (
      <>
        <Typography variant='h4' mb={2}>
          {t('applicantOnboarding.jobSearchPreferences.formLabels.countryBase')}
        </Typography>
        <DachCountrySelect
          name='applicantOnboarding.jobSearchPreferences.baseCountry.isoCode'
          label={t('applicantOnboarding.jobSearchPreferences.formLabels.countrySelect')}
          onChange={onCountrySelect}
          value={formik.values.applicantOnboarding.jobSearchPreferences.baseCountry.isoCode}
        />
      </>
    );
  }

  if (formik.values.applicantOnboarding.jobSearchPreferences.locationType === 'specific') {
    return (
      <>
        <Typography variant='h4' mb={2}>
          {t('applicantOnboarding.jobSearchPreferences.formLabels.countrySpecific')}
        </Typography>
        <DachCountrySelect
          name='applicantOnboarding.jobSearchPreferences.preferredLocation.country.isoCode'
          label={t('applicantOnboarding.jobSearchPreferences.formLabels.countrySelect')}
          onChange={onSpecificCountrySelect}
          value={formik.values.applicantOnboarding.jobSearchPreferences.preferredLocation.country.isoCode}
        />
      </>
    );
  }
};
